/**
 * Phone verification services
 *
 * Handles sending and validating phone verification codes.
 *
 * Endpoints:
 *   POST /api/verifications/phone_number         — sends an SMS with a 4-digit code
 *   POST /api/verifications/phone_number/verify  — verifies the 4-digit code
 *   GET  /api/validate_phone                     — checks if a phone number is valid and not banned
 */
import { createApiWithNewBasePath as api } from "@api";

export const sendVerificationCode = (phoneNumber: string) =>
  api.post<{ phone_number: string }, void>("verifications/phone_number", {
    phone_number: phoneNumber,
  });

export const verifyCode = (confirmationCode: string) =>
  api.post<{ confirmation_code: string }, void>(
    "verifications/phone_number/verify",
    { confirmation_code: confirmationCode }
  );

export const validatePhone = (phoneNumber: string) =>
  api.get<{ phone_number: string }, { valid: boolean }>("validate_phone", {
    phone_number: phoneNumber,
  });
